import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../../Config";
import {
  displayAvailabilityDateUnitNameText,
  formatDate,
} from "../../../../../../Helper_functions";

const DetailsModal = (props) => {
  const [Type, setType] = useState("position");
  const [Title, setTitle] = useState("");
  const [Country, setCountry] = useState("");
  const [Description, setDescription] = useState("");
  const [HasBeenRejected, setHasBeenRejected] = useState(false);
  const [HasCooldown, setHasCooldown] = useState(false);
  const [MonthsToReApply, setMonthsToReapply] = useState();
  const [Details, setDetails] = useState();

  useEffect(() => {
    if (props.Details.position) {
      setTitle(props.Details.position.title);
      setDescription(props.Details.position.description);
      setCountry(props.Details.position.workCity);
      setType("position");
      setDetails(props.Details.position);
    } else if (props.Details.activity) {
      setTitle(props.Details.activity.title);
      setDescription(props.Details.activity.description);
      setCountry(props.Details.activity.workCity);
      setType("activity");
      setDetails(props.Details.activity);
    } else {
      setTitle(props.Details.project.title);
      setDescription(props.Details.project.description);
      setCountry(props.Details.project.workCity);
      setType("project");
      setDetails(props.Details.project);
    }
    checkRejectionStatus();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const checkRejectionStatus = () => {
    if (
      props.Details.application === null ||
      props.Details.application.lastRejectionTime === null
    ) {
      setHasBeenRejected(false);
    } else if (props.Details.application.lastRejectionTime !== null) {
      setHasBeenRejected(true);
      let RejectionDate = props.Details.application.lastRejectionTime;
      let RejectionMilliSeconds = new Date(RejectionDate).getTime();
      let Now = new Date().getTime();
      //each day is 86400000 milliseconds, 6 months time is 15552000000 milliseconds (180 days)
      let Difference = Now - RejectionMilliSeconds;
      if (Difference < 15552000000) {
        let DaysDifference = Difference / 86400000;
        let DaysLeft = 180 - DaysDifference;
        setMonthsToReapply(parseInt(DaysLeft / 30 + 1));
        setHasCooldown(true);
      } else {
        setHasCooldown(false);
      }
    }
  };

  const toggleLike = () => {
    if (props.MoreLikeThisIsActive) {
      likeMoreLikeThisItem();
    } else {
      likeRecommendation();
    }
  };

  const likeMoreLikeThisItem = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "LIKE",
    };

    if (props.Details.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.id = props.Details.id;
    } else if (props.Details.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.id = props.Details.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.Details.id;
    }

    if (
      document
        .getElementById("detail-like")
        .classList.contains("overlayed-no-animation") ||
      document.getElementById("detail-like").classList.contains("overlayed")
    ) {
      document
        .getElementById("detail-like")
        .classList.remove("overlayed", "overlayed-no-animation");
    } else {
      document
        .getElementById("detail-dislike")
        .classList.remove("overlayed", "overlayed-no-animation");
      document
        .getElementById("detail-like")
        .classList.add("overlayed", "overlayed-no-animation");
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/similar/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        props.RefreshData(Type);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const likeRecommendation = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "LIKE",
    };

    if (props.Details.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.projectRecommendationId = props.Details.id;
    } else if (props.Details.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.activityRecommendationId = props.Details.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Details.id;
    }

    if (
      document
        .getElementById("detail-like")
        .classList.contains("overlayed-no-animation") ||
      document.getElementById("detail-like").classList.contains("overlayed")
    ) {
      document
        .getElementById("detail-like")
        .classList.remove("overlayed", "overlayed-no-animation");
    } else {
      document
        .getElementById("detail-dislike")
        .classList.remove("overlayed", "overlayed-no-animation");
      document
        .getElementById("detail-like")
        .classList.add("overlayed", "overlayed-no-animation");
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        props.RefreshData(Type);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleDislike = () => {
    if (props.MoreLikeThisIsActive) {
      dislikeMoreLikeThisItem();
    } else {
      dislikeRecommendation();
    }
  };
  const dislikeMoreLikeThisItem = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "DISLIKE",
    };

    if (props.Details.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.id = props.Details.id;
    } else if (props.Details.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.id = props.Details.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.Details.id;
    }

    if (
      document
        .getElementById("detail-dislike")
        .classList.contains("overlayed-no-animation") ||
      document.getElementById("detail-dislike").classList.contains("overlayed")
    ) {
      document
        .getElementById("detail-dislike")
        .classList.remove("overlayed", "overlayed-no-animation");
    } else {
      document
        .getElementById("detail-dislike")
        .classList.add("overlayed", "overlayed-no-animation");
      document
        .getElementById("detail-like")
        .classList.remove("overlayed", "overlayed-no-animation");
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/similar/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        props.RefreshData(Type);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const dislikeRecommendation = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "DISLIKE",
    };

    if (props.Details.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.projectRecommendationId = props.Details.id;
    } else if (props.Details.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.activityRecommendationId = props.Details.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Details.id;
    }

    if (
      document
        .getElementById("detail-dislike")
        .classList.contains("overlayed-no-animation") ||
      document.getElementById("detail-dislike").classList.contains("overlayed")
    ) {
      document
        .getElementById("detail-dislike")
        .classList.remove("overlayed", "overlayed-no-animation");
    } else {
      document
        .getElementById("detail-dislike")
        .classList.add("overlayed", "overlayed-no-animation");
      document
        .getElementById("detail-like")
        .classList.remove("overlayed", "overlayed-no-animation");
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        props.RefreshData(Type);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const toggleSave = () => {
    if (props.MoreLikeThisIsActive) {
      saveMoreLikeThisItem();
    } else {
      saveRecommendedItem();
    }
  };

  const saveMoreLikeThisItem = () => {
    let ActionURL;
    let ActionType;
    let Data = {};
    if (props.Details.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.id = props.Details.id;
    } else if (props.Details.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.id = props.Details.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.Details.id;
    }

    if (
      document.getElementById("detail-save").classList.contains("saved") ||
      document
        .getElementById("detail-save")
        .classList.contains("saved-no-animation")
    ) {
      document
        .getElementById("detail-save")
        .classList.remove("saved", "saved-no-animation");
    } else {
      document
        .getElementById("detail-save")
        .classList.add("saved", "saved-no-animation");
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/similar/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        props.RefreshData(Type);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  // bookmarks a recommendation and not a "more like this item"
  const saveRecommendedItem = () => {
    let ActionURL;
    let ActionType;
    let Data = {};
    if (props.Details.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.recommendationId = props.Details.id;
    } else if (props.Details.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.recommendationId = props.Details.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Details.id;
    }

    if (
      document.getElementById("detail-save").classList.contains("saved") ||
      document
        .getElementById("detail-save")
        .classList.contains("saved-no-animation")
    ) {
      document
        .getElementById("detail-save")
        .classList.remove("saved", "saved-no-animation");
    } else {
      document
        .getElementById("detail-save")
        .classList.add("saved", "saved-no-animation");
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        props.RefreshData(Type);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 30) {
        return Title;
      } else {
        return Title.slice(0, 26) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 40) {
        return Title;
      } else {
        return Title.slice(0, 36) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return null;
      } else {
        return <p className="popup-text">{Title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 35) {
        return null;
      } else {
        return <p className="popup-text">{Title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 45) {
        return null;
      } else {
        return <p className="popup-text">{Title}</p>;
      }
    }
  };
  const displayJPACode = () => {
    if (props.Details.position) {
      return props.Details.position.globalPositionCode;
    } else if (props.Details.activity) {
      return props.Details.activity.globalActivityCode;
    } else {
      return props.Details.project.globalProjectCode;
    }
  };
  const displayJPASkills = () => {
    let Skills = [];
    props.Details.requiredSkills.map((Skill) => {
      Skills.push(Skill.title);
    });
    if (Skills.length > 0) {
      return Skills.join(', ');
    } else {
      return translateText("not_available");
    }
  };

  const displayAvailability = () => {
    let Start;
    if (Type === "position") {
      Start = props.Details.position.startDate;
    } else if (Type === "project") {
      Start = props.Details.project.startDate;
    } else if (Type === "activity") {
      Start = props.Details.activity.startDate;
    }

    let End;
    if (Type === "position") {
      End = props.Details.position.endDate;
    } else if (Type === "project") {
      End = props.Details.project.endDate;
    } else if (Type === "activity") {
      End = props.Details.activity.endDate;
    }

    let Unit;
    if (Type === "position") {
      Unit = props.Details.position.availabilityUnit;
    } else if (Type === "project") {
      Unit = props.Details.project.availabilityUnit;
    } else if (Type === "activity") {
      Unit = props.Details.activity.availabilityUnit;
    }

    let Value;
    if (Type === "position") {
      Value = props.Details.position.availabilityValue;
    } else if (Type === "project") {
      Value = props.Details.project.availabilityValue;
    } else if (Type === "activity") {
      Value = props.Details.activity.availabilityValue;
    }

    const checkNull = (Value, IsDate) => {
      if (Value === null) {
        return "";
      } else if (IsDate) {
        return formatDate(Value);
      } else {
        return Value;
      }
    };
    const returnFrom = (startDate) => {
      if (startDate) {
        return " " + translateText("from") + " ";
      } else {
        return "";
      }
    };
    const returnTo = (endDate) => {
      if (endDate) {
        return " " + translateText("to") + " ";
      } else {
        return "";
      }
    };

    if (Value) {
      return (
        checkNull(Value) +
        " " +
        checkNull(displayAvailabilityDateUnitNameText(Unit, props.LangData)) +
        returnFrom(Start) +
        checkNull(Start, true) +
        returnTo(End) +
        checkNull(End, true)
      );
    } else {
      return translateText("not_specified");
    }
  };

  return (
    <div className="details-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="details-modal">
        <section className="details-modal-head">
          <span>
            <h1>{shortenTitle(Title)}</h1>
            {handleDisplayPopup()}
            <p>
              {Country !== null ? Country : null}
              {Country ? "," : ""}
              {" ID:" + displayJPACode()}
            </p>
          </span>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="details-modal-body">
          <div className="actions">
            <button
              id={"detail-dislike"}
              onClick={() => toggleDislike()}
              className={
                props.Details.reactionType === "DISLIKE"
                  ? "rounded overlayed-no-animation"
                  : "rounded"
              }
            >
              <i className="feather-thumbs-down"></i>
            </button>
            <button
              id={"detail-like"}
              onClick={() => toggleLike()}
              className={
                props.Details.reactionType === "LIKE"
                  ? "rounded overlayed-no-animation"
                  : "rounded"
              }
            >
              <i className="feather-thumbs-up"></i>
            </button>
            <button
              onClick={() => toggleSave()}
              id={"detail-save"}
              className={
                props.Details.bookmarked
                  ? "bookmark saved-no-animation"
                  : "bookmark"
              }
            >
              <i className="feather-bookmark"></i>
              <i className="feather-plus"></i>
            </button>
          </div>
          {props.Details.reviewer !== null ? (
            <React.Fragment>
              {props.Details.reviewer.imageThumbnailUrl === null ? (
                <section className="hiring-manager">
                  <span
                    className="avatar-placeholder"
                    style={{
                      backgroundColor:
                        props.Details.reviewer.backgroundColorCode,
                      color: props.Details.reviewer.textColorCode,
                    }}
                  >
                    <p>
                      {props.Details.reviewer.firstName
                        .slice(0, 1)
                        .toUpperCase() +
                        props.Details.reviewer.lastName
                          .slice(0, 1)
                          .toUpperCase()}
                    </p>
                  </span>
                  <span className="manager-info">
                    <p className="manager-name">
                      {props.Details.reviewer.firstName +
                        " " +
                        props.Details.reviewer.lastName}
                    </p>
                    <p className="manager-pos">
                      {translateText("hiring_manager")}
                    </p>
                  </span>
                </section>
              ) : (
                <section className="hiring-manager">
                  <img
                    alt="reviewer-image"
                    className="reviewer-avatar"
                    src={props.Details.reviewer.imageThumbnailUrl}
                  />
                  <span className="manager-info">
                    <p className="manager-name">
                      {props.Details.reviewer.firstName +
                        " " +
                        props.Details.reviewer.lastName}
                    </p>
                    <p className="manager-pos">
                      {translateText("hiring_manager")}
                    </p>
                  </span>
                </section>
              )}
            </React.Fragment>
          ) : null}
          {Details === undefined ? null : (
            <div className="details-info">
              <section className="info-row">
                <p className="details-info row-name">
                  {translateText("description")}
                </p>
                <p className="details-info">
                  {Description === "" || Description === null
                    ? translateText("not_available")
                    : Description}
                </p>
              </section>
              <section className="info-row">
                <p className="details-info row-name">
                  {translateText("availability")}
                </p>
                <p className="details-info">{displayAvailability()}</p>
              </section>
              <section className="info-row">
                <p className="details-info row-name">
                  {translateText("skills")}
                </p>
                <p className="details-info">{displayJPASkills()}</p>
              </section>
              <section className="info-row">
                <p className="details-info row-name">
                  {translateText("years_of_experience")}
                </p>
                <p className="details-info">
                  {Details.yearsOfExperience
                    ? Details.yearsOfExperience
                    : translateText("not_available")}
                </p>
              </section>
            </div>
          )}
          {HasBeenRejected && HasCooldown ? (
            <p className="rejection-text">
              {translateText("rejected_application_details_modal_1")}{" "}
              {MonthsToReApply}
              {translateText("rejected_application_details_modal_2")}
            </p>
          ) : null}
          {props.Details.application === null ||
          (HasBeenRejected && !HasCooldown) ? (
            <React.Fragment>
              {props.IsAvailable ? (
                <section className="jpa-actions disabled-cancel">
                  <span
                    onClick={() =>
                      props.ToggleVerify(props.Details, "Anonymous")
                    }
                  >
                    {translateText("anonymous_apply")}
                  </span>
                  <span
                    onClick={() => props.ToggleVerify(props.Details, "Normal")}
                  >
                    {translateText("apply")}
                  </span>
                </section>
              ) : (
                <section className="jpa-actions disabled-actions">
                  <span className="disabled-cancel">
                    {translateText("anonymous_apply")}
                  </span>
                  <span className="disabled-cancel">
                    {translateText("apply")}
                  </span>
                </section>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {props.Details.application.details[0].subStage === "DONE" &&
              props.Details.application.details[1].subStage === "PENDING" &&
              props.Details.application.details[2].subStage === "PENDING" &&
              props.Details.application.details[3].subStage === "PENDING" &&
              props.Details.application.status !== "CANCELLED" ? (
                <section className="jpa-actions post-apply-actions ">
                  <span
                    className="cancel-application"
                    onClick={() => props.ToggleCancel(props.Details)}
                  >
                    {translateText("cancel_application")}
                  </span>
                </section>
              ) : (
                <React.Fragment>
                  {props.Details.application.status !== "CANCELLED" ? (
                    <React.Fragment>
                      {props.Details.application.details[0].subStage ===
                        "DONE" &&
                      props.Details.application.details[1].subStage ===
                        "PENDING" &&
                      props.Details.application.details[3].subStage ===
                        "PENDING" &&
                      props.Details.application.details[2].subStage ===
                        "INVITE_SENT" ? (
                        <section className="jpa-actions">
                          <span
                            className="cancel-application"
                            onClick={() =>
                              props.HandleVerifyInterview(
                                props.Details,
                                "REJECT"
                              )
                            }
                          >
                            {translateText("reject_invitation")}
                          </span>
                          <span
                            className="disabled-cancel"
                            onClick={() =>
                              props.HandleVerifyInterview(
                                props.Details,
                                "ACCEPT"
                              )
                            }
                          >
                            {translateText("accept_invitiation")}
                          </span>
                        </section>
                      ) : (
                        <React.Fragment>
                          {props.Details.application.details[0].subStage ===
                            "DONE" &&
                          props.Details.application.details[1].subStage ===
                            "DONE" &&
                          props.Details.application.details[3].subStage ===
                            "PENDING" &&
                          props.Details.application.details[2].subStage ===
                            "INVITE_SENT" ? (
                            <section className="jpa-actions">
                              <span
                                className="cancel-application"
                                onClick={() =>
                                  props.HandleVerifyInterview(
                                    props.Details,
                                    "REJECT"
                                  )
                                }
                              >
                                {translateText("reject_invitation")}
                              </span>
                              <span
                                className="disabled-cancel"
                                onClick={() =>
                                  props.HandleVerifyInterview(
                                    props.Details,
                                    "ACCEPT"
                                  )
                                }
                              >
                                {translateText("accept_invitiation")}
                              </span>
                            </section>
                          ) : (
                            <React.Fragment>
                              {props.Details.application.details[3].subStage ===
                                "IN_PROGRESS" &&
                              props.Details.application.details[3].stage ===
                                "FINAL_DECISION" &&
                              props.Details.application.type !== "DEFAULT" ? (
                                <section className="jpa-actions">
                                  <span
                                    className="cancel-application"
                                    onClick={() =>
                                      props.HandleVerifyInterview(
                                        props.Details,
                                        "REJECT"
                                      )
                                    }
                                  >
                                    {translateText("cancel")}
                                  </span>
                                  <span
                                    className="disabled-cancel"
                                    onClick={() =>
                                      props.HandleVerifyInterview(
                                        props.Details,
                                        "ACCEPT"
                                      )
                                    }
                                  >
                                    {translateText("proceed")}
                                  </span>
                                </section>
                              ) : (
                                <React.Fragment>
                                  {!HasCooldown && HasBeenRejected ? (
                                    <section className="jpa-actions">
                                      <span
                                        onClick={() =>
                                          props.ToggleVerify(
                                            props.Details,
                                            "Anonymous"
                                          )
                                        }
                                      >
                                        {translateText("anonymous_apply")}
                                      </span>
                                      <span
                                        onClick={() =>
                                          props.ToggleVerify(
                                            props.Details,
                                            "Normal"
                                          )
                                        }
                                      >
                                        {translateText("apply")}
                                      </span>
                                    </section>
                                  ) : (
                                    <React.Fragment>
                                      {props.Details.application
                                        .sendConfirmationReset ? (
                                        <section className="jpa-actions">
                                          <span
                                            onClick={() =>
                                              props.ToggleConfirmResetApplication(
                                                props.Details
                                              )
                                            }
                                          >
                                            {translateText("confirm_reset")}
                                          </span>
                                        </section>
                                      ) : (
                                        <section className="jpa-actions disabled-actions">
                                          <span className="disabled-cancel">
                                            {translateText(
                                              "cancel_application"
                                            )}
                                          </span>
                                        </section>
                                      )}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ) : (
                    <section className="jpa-actions disabled-actions">
                      <span className="disabled-cancel">
                        {translateText("anonymous_apply")}
                      </span>
                      <span className="disabled-cancel">
                        {translateText("apply")}
                      </span>
                    </section>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </section>
      </div>
    </div>
  );
};

export default DetailsModal;
